import { COMPOSER_SERVICE_BASE_URL } from "constants";
import { useState } from "react";


const API_BASE = COMPOSER_SERVICE_BASE_URL;

const C = {
  bg: "#ffffff",
  bgSurface: "#f7f6f3",
  border: "rgba(0,0,0,0.10)",
  borderMid: "rgba(0,0,0,0.16)",
  text: "#1a1a1a",
  textMuted: "#6b6b6b",
  textFaint: "#a0a0a0",
  blue: "#3b82f6",
  blueBg: "#eff6ff",
};

const Icon = ({ name, size = 14, style = {} }) => (
  <i
    className={`ti ti-${name}`}
    style={{ fontSize: size, lineHeight: 1, ...style }}
    aria-hidden="true"
  />
);


// live preview modal — iframes the public preview endpoint
const DEVICES = [
  { id: "desktop", icon: "device-desktop", width: "100%" },
  { id: "tablet",  icon: "device-tablet",  width: 768 },
  { id: "mobile",  icon: "device-mobile",  width: 390 },
];

export default function PreviewModal({ template, onClose, onUse }) {
  const [maximized, setMaximized] = useState(false);
  const [device, setDevice] = useState("desktop");

  if (!template) return null;

  const activeDevice = DEVICES.find((d) => d.id === device);
  const iframeWidth = activeDevice.width;

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 1000,
        background: "rgba(0,0,0,0.55)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: maximized ? 0 : 32,
        transition: "padding 0.18s ease",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: maximized ? "100vw" : "100%",
          maxWidth: maximized ? "100vw" : 1100,
          height: maximized ? "100vh" : "100%",
          maxHeight: maximized ? "100vh" : 760,
          background: C.bg,
          borderRadius: maximized ? 0 : 14,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          boxShadow: maximized ? "none" : "0 30px 80px rgba(0,0,0,0.3)",
          transition: "all 0.18s ease",
        }}
      >
        {/* header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "12px 20px",
            borderBottom: `0.5px solid ${C.border}`,
            flexShrink: 0,
            gap: 12,
          }}
        >
          <div style={{ minWidth: 0, flexShrink: 1 }}>
            <div style={{ fontSize: 14, fontWeight: 600, color: C.text, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {template.name}
            </div>
            <div style={{ fontSize: 11, color: C.textMuted, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {template.description}
            </div>
          </div>

          {/* device toggle — centered */}
          <div style={{ display: "flex", border: `0.5px solid ${C.border}`, borderRadius: 8, overflow: "hidden", flexShrink: 0 }}>
            {DEVICES.map((d) => (
              <button
                key={d.id}
                onClick={() => setDevice(d.id)}
                title={d.id}
                style={{
                  width: 34,
                  height: 30,
                  border: "none",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: device === d.id ? C.text : C.bgSurface,
                  color: device === d.id ? "#fff" : C.textMuted,
                  transition: "all 0.12s",
                }}
              >
                <Icon name={d.icon} size={14} />
              </button>
            ))}
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
            <button
              onClick={() => onUse(template)}
              style={{
                padding: "7px 14px",
                border: "none",
                borderRadius: 7,
                background: C.text,
                color: "#fff",
                fontSize: 12,
                fontWeight: 500,
                cursor: "pointer",
                fontFamily: "inherit",
                whiteSpace: "nowrap",
              }}
            >
              Use this template
            </button>

            <button
              onClick={() => setMaximized((m) => !m)}
              title={maximized ? "Restore" : "Maximize"}
              style={{ width: 30, height: 30, border: "none", borderRadius: 7, background: C.bgSurface, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: C.textMuted }}
            >
              <Icon name={maximized ? "minimize" : "maximize"} size={14} />
            </button>

            <button
              onClick={onClose}
              title="Close"
              style={{ width: 30, height: 30, border: "none", borderRadius: 7, background: C.bgSurface, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: C.textMuted }}
            >
              <Icon name="x" size={15} />
            </button>
          </div>
        </div>

        {/* iframe viewport — scrollable container, fixed-width frame for device sim */}
        <div
          style={{
            flex: 1,
            overflow: "auto",
            display: "flex",
            justifyContent: "center",
            background: device === "desktop" ? C.bg : "#e8e8e6",
            padding: device === "desktop" ? 0 : "20px 0",
          }}
        >
          <iframe
            src={`${API_BASE}/api/v1/templates/${template.id}/preview`}
            title={`${template.name} preview`}
            style={{
              border: device === "desktop" ? "none" : `1px solid ${C.border}`,
              width: iframeWidth,
              height: device === "desktop" ? "100%" : "100%",
              flexShrink: 0,
              borderRadius: device === "desktop" ? 0 : 10,
              boxShadow: device === "desktop" ? "none" : "0 4px 20px rgba(0,0,0,0.08)",
              background: "#fff",
            }}
          />
        </div>
      </div>
    </div>
  );
}